module.exports = __webpack_public_path__ + "static/media/financial1.ee241e14.png";